import { Services, getServicePathToAPI, joinURLPath } from '@sigma-frontend-libs/commons'
import Actions from '@sigma-legacy-libs/essentials/lib/utils/Actions'

import { globalErrorHandler, request } from '@/utils'

import render from './render'

const pathToAPI = getServicePathToAPI(Services['url-shortener-settings/presets'])
const urlShortenerPresetTitles = new Map()

export default {
  name: 'RulesUrlShortenerPresetValue',

  props: {
    value: null
  },

  data() {
    return {
      loading: false,
      title: undefined
    }
  },

  computed: {
    label() {
      return this.title || this.value
    }
  },

  watch: {
    value: {
      async handler() {
        await this.getTitle()
      },
      immediate: true
    }
  },

  methods: {
    async getTitle() {
      this.title = undefined

      if (!Actions.validateValue(this.value, Actions.tagsMeta.urlShortenerPresetId.tag)) {
        return
      }

      if (urlShortenerPresetTitles.has(this.value)) {
        this.title = urlShortenerPresetTitles.get(this.value)
      } else {
        this.loading = true

        try {
          const response = await request.get(joinURLPath(pathToAPI, this.value))
          const title = response?.title

          if (typeof title === 'string' && title) {
            urlShortenerPresetTitles.set(this.value, title)
            this.title = title
          }
        } catch (error) {
          globalErrorHandler(error)
        } finally {
          this.loading = false
        }
      }
    }
  },

  render
}
